<template>
  <div class="drawerWrap">
    <div class="drawerBody">
      <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
        <!-- <el-form-item label="巡检设备类型" prop="typeId">
          <el-select v-model="parentId" placeholder="请选择父项类型" clearable @change="selectChange" :disabled="handleType=='edit'?true:false">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="form.typeId" placeholder="请选择子项类型" clearable :disabled="handleType=='edit'?true:false">
            <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="巡检设备类型" prop="typeId">
            <treeselect v-model="form.typeId" noResultsText="无匹配项" noOptionsText="暂无数据" :show-count="true" :disable-branch-nodes="true" :flat="false" :disabled="handleType=='edit'?true:false" :multiple="false" :defaultExpandLevel="Infinity" :options="optionsOrg" placeholder="请选择巡检设备类型" :normalizer="normalizer" @input="inputChange" />
          </el-form-item>
<!--        <el-form-item label="巡检项名称" prop="title">
          <el-input v-model="form.title" minlength="1" maxlength="20" placeholder="请输入巡检项名称"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="巡检项内容" prop="content">
          <el-input v-model="form.content" placeholder="请输入巡检项内容"></el-input>
        </el-form-item> -->
		<el-form-item label="巡检项内容" prop="content">
			<el-input type="textarea" v-model="form.content" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
		</el-form-item>
      </el-form>
    </div>
    <div class="drawerFoot">
      <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
      <el-button @click="cancelHandle()">取 消</el-button>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    Treeselect
  },
    props: {
      templateId: {
        type: String,
        default: ""
      },
      templateName: {
        type: String,
        default: ""
      },
      loading: {
        type: Boolean,
        default: false
      },
      handleType:{
        type: String,
        default: ""
      },
      editData:{
        type: Object,
        default: {}
      },
      parentData:{
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        optionsOrg:[],
        form: {
          title:'',
          typeId:null,
          content:''
        },
        formRules: {
          title: [
            {
              required: true,
              validator: this.validateTemplateName,
              trigger: "blur"
            }
          ],
          typeId: [
            {
              required: true,
              validator: "巡检设备类型不能为空",
              trigger: "blur"
            }
          ]
        },
        options:[],
        options1:[],
        parentId:null
      };
    },
    created() {                
    },
    mounted() {
      this.init();
    },
    methods: {
      /**
       * 页面数据校验
       */
      validateTemplateName(rule, value, callback) {
        if (value === "") {
          callback(new Error("巡检项名称不能为空"));
        } else if (value.length > 20) {
          callback(new Error("巡检项名称长度不能超过20个字符"));
        } else {
          callback()
        }
      },
      /**
       * 页面初始化
       */
      init() {
        // console.log(this.parentData);  
        console.log(this.editData);
        //初始化"巡查设备类型"下拉列表
        // this.getParentType()
        if(this.handleType=="add"){
          this.form= {
            title:'',
            typeId:null,
            content:''
          }
          this.getTreeType()
        }else if(this.handleType=="edit"){
          // this.request.get("/front/polling/type/getEditInfo", {"parentId": this.parentData.parentId}).then(res => {
          //   console.log(res);
          //   if (res.code == 200) {
          //     this.options=[
          //       {
          //         id:res.data.parentTypeId,
          //         name:res.data.parentTypeName
          //       }
          //     ]
          //     this.parentId=res.data.parentTypeId
          //     this.form.typeId=this.parentData.typeName
          //   }
          // }).catch(error => console.log(error));
          this.request.get("/front/polling/type/getTypeTree", {"typeName":""}).then(res => {
            if (res.code == 200) {
              this.optionsOrg = res.data
              this.form= {
                title:this.editData.title,
                typeId:this.editData.typeId,
                content:this.editData.content
              }
            }
          }).catch(error => console.log(error));
        }
      },
      // 获取树结构巡检设备类型
      getTreeType(){
        this.request.get("/front/polling/type/getTypeTree", {"typeName":""}).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.optionsOrg = res.data
              let typeArry = []
              let flag = true
              this.optionsOrg.forEach(item=>{
                if(flag&&item.children!==null&&item.children!=='null'&&item.children.length){
                  typeArry=item.children
                  flag=false
                }
              })
              this.form.typeId = typeArry[0].typeId
            }
          }).catch(error => console.log(error));
      },
      //获取父级设备类型
      getParentType() {
          this.request.get("/front/polling/type/getAllParent", {"tenantId": "123456"}).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.options=res.data
            }
          }).catch(error => console.log(error));
      },
      selectChange(data){
        this.request.get("/front/polling/type/getByParentId", {"parentId": data}).then(res => {
            console.log(res);
            if (res.code == 200) {
              if(res.msg=='暂无数据'){
                this.msg.warn('子项类型暂无数据，请重新选择父项类型。')
                this.parentId=null
                this.form.typeId=null
              }else{
                this.options1=res.data           
                this.msg.success('子项类型存在，请进行选择。')     
              }
            }
          }).catch(error => console.log(error));
      },
      /**
       * 取消
       */
      cancelHandle() {
        this.$emit("cancel", false);
      },
      /**
       * 确认
       */
      confirmHandle() {
        //  if(this.form.title==""){
        //     return this.msg.error("请填写巡检项名称");
        //  }else 
         if(this.form.typeId==null){
            return this.msg.error("请选择巡检设备类型");
         }else{
           if(this.handleType=='edit'){
            delete this.form.typeId             
           }
           // console.log(1112223334455666, this.form);
           // return
            this.$emit("confirm", this.form);
            this.$emit("update:loading", true);
         }
      },
        //树形结构
      normalizer(node){
        // console.log(12123, node)
        //去掉children=null的属性
        if(node.children==null||node.children=='null'){
          delete node.children;
        }
        return {
          id: node.typeId,
          label:node.name,
          children: node.children,
        }
        // 安前宾说没用一下判断没用-2025-04-25
        return
        if(node.tenantId){
          return {
            id: node.id,
            label:node.name,
            children: node.children,
            // isDisabled:true
          };
        }else{
          return {
            id: node.typeId,
            label:node.name,
            children: node.children,
          };
        }
      },
      inputChange(data){
        // console.log(data)
        if(data==undefined){
          this.form.typeId=null
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .drawerWrap {
    font-size: 0;
    .openClose {
      width: 48px;
      height: 48px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%
      }
    }

    .contents {
      .checkCons {
        .title {
          width: 105px;
          text-align: right;
          margin-bottom: 20px;
          font-size: 14px;
          color: #6e6e6e;
          font-weight: 400;
        }

        .cons {
          overflow: hidden;

          h3 {
            float: left;
            width: 105px;
            text-align: right;
            font-size: 15px;
          }

          .lists {
            float: left;
            margin-left: 20px;

            ul {
              li {
                line-height: 24px;
                span {
                  display: inline-block;
                  width: 225px;
                  font-size: 14px;
                  color: #6e6e6e;
                }

                i {
                  font-size: 14px;
                  color: #6e6e6e;
                  font-weight: normal;
                  margin-left: 20px;
                  cursor: pointer;
                  padding: 5px 10px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .drawerWrap {
    .el-transfer {
      .el-transfer-panel {
        text-align: left;
        width: 250px;
      }

      .el-transfer__buttons {
        width: 65px;
        text-align: center;

        .el-button {
          margin: 5px 0;
          width: 56px;
        }
      }
    }

    .el-switch {
      width: 100%;
    }

    .el-image {
      margin-right: 20px;
    }

    .el-form {
      margin-top: 20px;

      .el-form-item__label {
        line-height: 50px;
      }

      .el-form-item__content {
        line-height: 50px;
      }

      .el-select {
        width: 100%;
      }

      .el-textarea {
        width: 270px;

        .el-textarea__inner {
          height: 100px !important;
          line-height: 20px;
          color: #6e6e6e;
          font-size: 14px;
        }
      }

      .el-input {
        width: 270px;

        .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .drawerBody .el-form-item__label,
    .sp {
      color: #6e6e6e;
    }
    .el-select .el-input .el-select__caret{
      line-height: 50px !important;
    }
  }
</style>
